import { store } from '@/store'
import { ACCESS_LEVELS } from '@/lib/consts.ts'
import { ROUTE_META_PARAMS } from '@/router/consts.ts'

export default {
  path: 'profile',
  name: 'profile',
  component: () => import('@/views/business/profile/index.vue'),
  meta: {
    hintKey: 'hintFeatureBusinessProfile',
  },
  children: [
    {
      path: 'edit-profile',
      name: 'edit-profile',
      component: () => import('@/views/business/profile/edit-profile/index.vue'),
    },
    {
      path: 'profile-images/:tab?',
      name: 'profile-images',
      component: () => import('@/views/business/profile/profile-images/index.vue'),
      props: true,
    },
    {
      path: 'portfolio',
      name: 'portfolio',
      component: () => import('@/views/business/profile/portfolio.vue'),
      meta: {
        hintKey: 'hintFeaturePortfolio',
        [ROUTE_META_PARAMS.ACCESS_LEVEL]: ACCESS_LEVELS.RECEPTION,
      },
      children: [
        {
          path: 'edit-photos/:imageId?',
          name: 'profile.portfolio.edit-photos',
          component: () => import('@/views/business/profile/portfolio/edit-photos.vue'),
          props: true,
        },
        {
          path: 'instagram-photos',
          name: 'profile.portfolio.instagram-photos',
          component: () => import('@/views/business/profile/portfolio/instagram-photos.vue'),
        },
      ],
    },
    {
      path: 'reviews',
      name: 'reviews',
      component: () => import('@/views/business/profile/reviews.vue'),
      meta: {
        hintKey: 'hintFeatureReviews',
        useSmartlook: true,
      },
    },
    {
      path: 'completeness',
      name: 'completeness',
      component: () => import('@/views/business/profile/completeness.vue'),
      meta: {
        hintKey: 'hintFeatureProfileCompleteness',
        useSmartlook: true,
      },
      beforeEnter: (to, _from, next) => {
        if (store.state.routingConfig?.config?.profile_completeness_hidden) {
          return next({ name: 'profile', params: to.params })
        }
        next()
      },
    },
    {
      path: 'umbrella',
      name: 'umbrella',
      component: () => import('@/views/business/profile/umbrella.vue'),
    },
  ],
}
